var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGas14Shared(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "207.93pt",
    height: "320pt",
    viewBox: "-106 0 207.93 320",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.089)",
    strokeWidth: 0.625
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.415 292.41h-77.241c-10.063 0-19.465 2.8418-27.588-1.8652v12.898c0 9.1431 7.4121 16.553 16.553 16.553h99.309c9.1431 0 16.553-7.4097 16.553-16.553v-12.898c-8.1226 4.707-17.522 1.8652-27.585 1.8652z",
    fill: "#0b1728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.897 0h-66.208c-6.0864 0.01709-11.016 4.9487-11.033 11.035v60.964c1.8213-0.16602 3.6401-0.27588 5.5176-0.27588h77.241c1.875 0 3.6963 0.10986 5.5176 0.27588v-60.964c-0.01953-6.0864-4.9487-11.018-11.035-11.035zm-11.035 38.621c0 3.0469-2.4707 5.5176-5.5176 5.5176h-33.103c-3.0469 0-5.5176-2.4707-5.5176-5.5176v-11.035c0-3.0469 2.4707-5.5176 5.5176-5.5176h33.103c3.0469 0 5.5176 2.4707 5.5176 5.5176z",
    fill: "#3771c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-50.827 66.206h77.241c30.471 0 55.171 24.702 55.171 55.173v121.38c0 30.471-24.7 55.173-55.171 55.173h-77.241c-30.471 0-55.173-24.702-55.173-55.173v-121.38c0-30.471 24.702-55.173 55.173-55.173z",
    fill: "#2c5aa0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.496 231.88v11.467c0 30.471-24.7 55.173-55.171 55.173h-77.241c-30.471 0-55.173-24.702-55.173-55.173l0.76703-11.149z",
    fill: "#d40000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-12.206 248.28c-11.035 0-44.138-2.0923-44.138-33.484 0.49805-10.356 5.0562-20.1 12.688-27.119 0.10254-0.0928 0.25635-0.10986 0.37598-0.0391 0.11963 0.0708 0.17822 0.21484 0.14404 0.34912-1.1816 3.4546-3.9502 14.25 8.8281 14.25 4.4141 0 8.8257-2.0898 8.8257-10.481 0-8.3936-11.033-16.746-11.033-29.304 0-13.926 8.3252-33.655 24.275-35.569 0.28076-0.0439 0.5542 0.10743 0.6665 0.36866 0.10986 0.26123 0.0293 0.56396-0.19775 0.73486-4.0601 2.4658-6.687 6.7334-7.0557 11.47 0 25.115 50.759 33.484 50.759 75.339 0 31.392-33.105 33.484-44.138 33.484z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.21234 0 0 .21234 -6.7941 8.3923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m321.07 317.79-57.346-33.939v-61.051c0-4.267-3.459-7.726-7.726-7.726s-7.726 3.459-7.726 7.726v61.051l-54.175 32.063c-3.673 2.173-4.887 6.912-2.714 10.584 1.443 2.438 4.016 3.792 6.657 3.792 1.338 0 2.693-0.348 3.928-1.078l54.03-31.978 57.202 33.854c1.235 0.731 2.59 1.078 3.928 1.078 2.641 0 5.214-1.355 6.657-3.792 2.173-3.672 0.958-8.411-2.715-10.584z",
    fill: "#efecef"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 116.55,
    r: 116.55,
    fill: "#62a4fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.24 20.652c13.018 18.811 20.652 41.634 20.652 66.243 0 64.37-52.182 116.55-116.55 116.55-24.609 0-47.431-7.633-66.243-20.652 21.035 30.395 56.139 50.31 95.901 50.31 64.37 0 116.55-52.182 116.55-116.55 1e-3 -39.762-19.915-74.866-50.31-95.901z",
    fill: "#5392f9"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e6f7fe"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 74.927,
    r: 41.626
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 116.55c-27.783 0-52.737 12.101-69.888 31.317-3.029 3.394-3.389 8.394-1 12.265 14.671 23.781 40.953 39.67 70.888 39.67s56.217-15.889 70.888-39.67c2.388-3.871 2.029-8.871-1-12.265-17.151-19.216-42.105-31.317-69.888-31.317z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 395.45,
    cy: 395.45,
    r: 116.55,
    fill: "#b3e59f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.69 299.55c13.018 18.811 20.652 41.634 20.652 66.242 0 64.37-52.182 116.55-116.55 116.55-24.609 0-47.431-7.633-66.242-20.652 21.035 30.395 56.139 50.31 95.901 50.31 64.37 1e-3 116.55-52.181 116.55-116.55 0-39.762-19.916-74.866-50.31-95.901z",
    fill: "#95d6a4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e6f7fe"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 395.45,
    cy: 353.82,
    r: 41.626
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.45 395.45c-27.783 0-52.737 12.101-69.888 31.317-3.029 3.394-3.389 8.394-1 12.265 14.671 23.781 40.953 39.67 70.888 39.67s56.217-15.889 70.888-39.67c2.388-3.871 2.029-8.871-1-12.265-17.151-19.216-42.105-31.317-69.888-31.317z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 116.55,
    cy: 395.45,
    r: 116.55,
    fill: "#e27f86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.8 299.55c13.018 18.811 20.652 41.634 20.652 66.242 0 64.37-52.182 116.55-116.55 116.55-24.609 0-47.431-7.633-66.243-20.652 21.036 30.395 56.14 50.311 95.902 50.311 64.37 0 116.55-52.182 116.55-116.55 0-39.762-19.916-74.866-50.311-95.901z",
    fill: "#df646e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e6f7fe"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.55,
    cy: 353.82,
    r: 41.626
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.55 395.45c-27.783 0-52.737 12.101-69.888 31.317-3.029 3.394-3.389 8.394-1 12.265 14.671 23.781 40.953 39.67 70.888 39.67s56.217-15.889 70.888-39.67c2.388-3.871 2.029-8.871-1-12.265-17.152-19.216-42.105-31.317-69.888-31.317z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas14Shared);
export default __webpack_public_path__ + "static/media/gas_1_4-shared.5660f80bacfc15021c20b7b20d772952.svg";
export { ForwardRef as ReactComponent };